import React from 'react'
import { Form, Select, Radio, Input, Checkbox, DatePicker } from 'antd'

class CaseCancellationForm extends React.Component {
  render() {
    return (
      <Form name="case-cancellation">
        <Form.Item 
          label={
            <React.Fragment>
              PIC 4
              <button className="field-actions">
                Recent Changes
              </button>
            </React.Fragment>
          }
        >
          <Select size="large" value="1">
            <Select.Option value="1">Staff</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Case Status" className="fluid-field">
          <Radio.Group>
            <Radio>None</Radio>
            <Radio>Cancelled No Fee</Radio>
            <Radio>Cancelled With Fee</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label="Reasons" className="fluid-field">
          <Radio.Group>
            <Radio>At the request of the Case Manager</Radio>
            <Radio>Doctor being unable to undertake assessment</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label="Send Cancellation Notice to">
          <Input size="large" />
        </Form.Item>
        <div className="fluid-field checkbox-field">
          <Checkbox>Booking Solicitor</Checkbox>
        </div>
        <div className="fluid-field checkbox-field">
          <Checkbox>Booking CM</Checkbox>
        </div>
        <div className="fluid-field checkbox-field">
          <Checkbox>Specialist</Checkbox>
        </div>
        <Form.Item label="Date of Cancellation">
          <DatePicker size="large" />
        </Form.Item>
        <Form.Item label="Comments" className="fluid-field">
          <Input.TextArea rows={6} />
        </Form.Item>
      </Form>
    )
  }
}

export default CaseCancellationForm